const appointmenttype = {
    state: {
      addAppointmentTypeDialog: {
        title: '新增预约类型信息',
        type: 'add'
      }
    },
    getters: {
        addAppointmentTypeDialog: state => state.addAppointmentTypeDialog,
    },
    mutations: {
      SET_APPOINTMENTTYPE_DIALOG_TITLE: (state, type) => {
        console.log("SET_APPOINTMENTTYPE_DIALOG_TITLE");
        if (type === 'add') {
          state.addAppointmentTypeDialog.title = '新增预约类型信息'
          state.addAppointmentTypeDialog.type = 'add'
        } else {
          state.addAppointmentTypeDialog.title = '编辑预约类型信息'
          state.addAppointmentTypeDialog.type = 'edit'
        }
      }
    },
    actions: {
  
    }
  }
  
  export default appointmenttype